var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 76,
    viewBox: "0 0 85 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12.6667C0 9.30726 1.49256 6.08544 4.14932 3.70998C6.80609 1.33452 10.4094 0 14.1667 0H56.6667C60.4239 0 64.0272 1.33452 66.684 3.70998C69.3408 6.08544 70.8333 9.30726 70.8333 12.6667V50.6667C70.8333 54.0261 69.3408 57.2479 66.684 59.6234C64.0272 61.9988 60.4239 63.3333 56.6667 63.3333H14.1667C10.4094 63.3333 6.80609 61.9988 4.14932 59.6234C1.49256 57.2479 0 54.0261 0 50.6667V12.6667Z",
    stroke: "#EEFFFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0208 28.5C27.9108 28.5 31.875 24.9555 31.875 20.5833C31.875 16.211 27.9108 12.6666 23.0208 12.6666C18.1308 12.6666 14.1666 16.211 14.1666 20.5833C14.1666 24.9555 18.1308 28.5 23.0208 28.5Z",
    stroke: "#EEFFFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3629 33.6331L14.1666 63.3333H57.1377C60.77 63.3333 64.2535 62.0432 66.8219 59.7467C69.3904 57.4502 70.8333 54.3355 70.8333 51.0878V50.6666C70.8333 49.191 70.2135 48.6241 69.0979 47.5316L54.825 33.6141C54.1598 32.9653 53.3506 32.4476 52.4491 32.094C51.5476 31.7405 50.5736 31.5588 49.5892 31.5606C48.6048 31.5623 47.6317 31.7476 46.7318 32.1044C45.8319 32.4613 45.0251 32.9819 44.3629 33.6331V33.6331Z",
    stroke: "#EEFFFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 76,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImage);
export default __webpack_public_path__ + "static/media/defaultImage.68f288b6f6b62f8cb8ee267c10ef581a.svg";
export { ForwardRef as ReactComponent };